import EventClient from "@2u-landing-pages/utils/event-client";

interface CalendlyEvent {
  event: string;
  payload?: any;
}

const isCalendlyEvent = (e: MessageEvent): e is MessageEvent & { data: CalendlyEvent } => {
  return e.origin === "https://calendly.com" && e.data?.event?.startsWith("calendly.");
};

let eventTypeViewedTimeout: NodeJS.Timeout | null = null;
let listenerCount = 0; // Track multiple components using the same listener
let handleMessage: ((e: MessageEvent) => void) | null = null;
let handleCloseBtn: ((e: MouseEvent) => void) | null = null;
let handleCloseOverlay: ((e: MouseEvent) => void) | null = null;

export const calendlyEventListener = () => {
  const webElementData = {
    elementType: "TY Page",
    htmlId: window.location.href,
    location: "Calendly Popup",
  };

  if (!handleMessage) {
    handleMessage = (e: MessageEvent) => {
      if (!isCalendlyEvent(e)) return;

      switch (e.data.event) {
        case "calendly.event_scheduled":
          EventClient.elementViewed({
            webElement: { ...webElementData, text: "Calendly - Event Scheduled Confirmation" },
          });
          break;
        case "calendly.date_and_time_selected":
          EventClient.elementViewed({ webElement: { ...webElementData, text: "Calendly - User Details Form" } });
          break;
        case "calendly.event_type_viewed":
          if (eventTypeViewedTimeout) clearTimeout(eventTypeViewedTimeout);

          eventTypeViewedTimeout = setTimeout(() => {
            EventClient.elementViewed({ webElement: { ...webElementData, text: "Calendly - Select Date and Time" } });
            eventTypeViewedTimeout = null;
          }, 2000);
          break;
      }
    };
  }

  if (!handleCloseBtn) {
    // Track clicks on the Calendly popup close button
    handleCloseBtn = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target?.classList.contains("calendly-popup-close")) {
        EventClient.elementClicked({
          webElement: { ...webElementData, text: "Calendly Popup - Close Button" },
        });
      }
    };
  }

  if (!handleCloseOverlay) {
    // Track clicks on the Calendly popup overlay (outer area)
    handleCloseOverlay = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target?.classList.contains("calendly-close-overlay")) {
        EventClient.applicationClicked({
          webElement: { ...webElementData, text: "Calendly Popup - Close Overlay" },
        });
      }
    };
  }

  if (listenerCount === 0) {
    // Only add listeners once
    window.addEventListener("message", handleMessage);
    document.addEventListener("click", handleCloseBtn, true);
    document.addEventListener("click", handleCloseOverlay, true);
  }
  listenerCount++;

  return () => {
    listenerCount--;
    if (listenerCount === 0) {
      if (handleMessage) window.removeEventListener("message", handleMessage);
      if (handleCloseBtn) document.removeEventListener("click", handleCloseBtn, true);
      if (handleCloseOverlay) document.removeEventListener("click", handleCloseOverlay, true);
      if (eventTypeViewedTimeout) {
        clearTimeout(eventTypeViewedTimeout);
        eventTypeViewedTimeout = null;
      }
    }
  };
};
